<template>
  <v-app id="inspire">
    <v-snackbar v-model="snackbar.show" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:actions>
        <v-btn variant="text" @click="snackbar.show = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
    <router-view v-if="enable_text === 4 && !loading"></router-view>
    <v-container
      v-else
      fluid
      class="fill-height"
      style="background-color: rgba(255, 255, 255, 0.5)"
    >
      <v-row justify="center" align="center">
        <v-col lg="2" md="2" sm="5" cols="6">
          <v-img src="@/assets/logo.svg"></v-img>
        </v-col>
        <v-col cols="12" class="text-center pa-0 ma-0">
          <v-progress-circular
            :size="50"
            :width="3"
            color="info"
            rotate="0"
            indeterminate
          >
            {{ loading ? "" : `${enable_text * 25}%` }}
          </v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useHomeStore } from "@/stores/home";
import { useBusinessStore } from "@/stores/business";
import { useAppStore } from "@/stores/app";
import { useUserStore } from "@/stores/user";
import { getLocacion } from "@/components/helpers/location";

export default {
  name: "App",
  metaInfo: {
    title: "Muy Hambriento - Encuentra los mejores platillos en tu ciudad",
    meta: [
      {
        name: "description",
        content:
          "Encuentra los mejores platillos en tu ciudad solo en muy hambriento.com",
      },
      {
        name: "keywords",
        content:
          "muy hambriento, Muy Hambriento, Muy Hambriento, Comida, Domicilio, domicilio, comida",
      },
    ],
  },
  data: () => ({
    //
    texto: "cargando delicias...",
    enable_text: 0,
    homeStore: useHomeStore(),
    userStore: useUserStore(),
    businessStore: useBusinessStore(),
    appStore: useAppStore(),
    snackbar: {
      show: false,
      text: "",
      color: "success",
    },
  }),
  methods: {
    updateCity() {
      let city_name = this.$session.get("city_name");
      this.homeStore.updateCityName(city_name);
    },
    async initialValidation() {
      this.enable_text = 1;
      if (this.userStore.isLoggedUser) {
        await this.userStore.loadUserData();
        this.enable_text = 2;
      } else {
        const location = await this.userStore.loadDefaultInformation();
        this.enable_text = 2;
        if (location.error) {
          this.snackbar.text = location.error;
          this.snackbar.color = "warning";
          this.snackbar.show = true;
        }
      }
      // await this.loadData();
      // this.updateCity();
      // this.loadTop();
      // this.loadMobil();
      // this.loadDesktop();
      this.enable_text = 3;
      await this.loadBusiness();
      this.enable_text = 4;
    },
    async loadTop() {
      await this.homeStore.getPublicityTopAction();
      this.enable_text++;
    },
    async loadMobil() {
      await this.homeStore.getPublicityMobilAction();
      this.enable_text++;
    },
    async loadDesktop() {
      await this.homeStore.getPublicityDesktopAction();
      this.enable_text++;
    },
    async loadBusiness() {
      await this.businessStore.getBusiness();
      this.enable_text++;
    },
    async loadData() {
      let user_name = this.$session.get("user_name");
      if (user_name) {
        await this.homeStore.updateUserName(user_name);
      }
    },
  },
  computed: {
    loading() {
      return this.appStore.isLoading;
    },
  },
  created() {
    this.initialValidation();
  },
};
</script>
<style>
.v-btn {
  text-transform: none !important;
}
.two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Número de líneas */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
